import utilParties from '../modules/utilParties';

function getRow(party) {
  let td = '';
  if ('seats' in party && party.seats != null) {
    td = `<td class="c-table__td">${party.seats.toLocaleString('de')} </td>`;
  }
  return `
    <tr class="c-table__tr c-table__tr--dotted">
      <td class="c-table__td c-table__td--partys">
        <span class="c-table__td-span ${party.partyCode}"></span>
        ${party.partyName}
      </td>
      ${td}
      <td class="c-table__td">${party.votesPct > 0 ? party.votesPct.toFixed(2).replaceAll(".", ",") : 0}</td>
      <td class="c-table__td">${party.votes.toLocaleString('de')}</td>
    </tr>
  `;
}

function getTBodys(table) {
  return {
    empty: table.querySelector('tbody.ac-data-table-empty'),
    withData: table.querySelector('tbody.ac-data-table-with-data'),
  };
}

function insertRow(tableBody, parties) {
  parties.forEach((party) => {
    tableBody.insertAdjacentHTML('beforeend', getRow(party));
  });
}

function populateTable(dataTable, parties) {
  const { empty, withData } = getTBodys(dataTable);
  const partiesVisibles = parties;
  empty.classList.add('hide');
  withData.classList.remove('hide');
  insertRow(withData, partiesVisibles);
  if (dataTable.nextElementSibling && dataTable.nextElementSibling.classList.contains('js-waiting-data')) {
    dataTable.nextElementSibling.classList.add('hide');
  }
}

function drawDataTable() {
  const dataTableCurrent = document.querySelector('.ac-data-table.ac-current');
  const dataTablePrevious = document.querySelector('.ac-data-table.ac-previous');
  let previousParty = {};

  window.dataManager.getHistoricParties().then((previousParties) => {
    if (previousParties) {
      previousParty = previousParties;
      populateTable(dataTablePrevious, previousParties, '.ac-previous');
    }

    window.dataManager.getParties().then((parties) => {
      if (parties) {
        const validParties = parties.filter((party) => parseInt(party.votes, 10) !== 0);
        if (validParties.length) {
          if (previousParty.length > 0) {
            parties.forEach((party) => {
              const prevParty = previousParty.find((p) => p.partyCode === party.partyCode);
              // eslint-disable-next-line no-param-reassign
              party.increase = utilParties.hasIncrease(prevParty ? prevParty.seats : 0, party.seats);
            });
          }
          populateTable(dataTableCurrent, parties, '.ac-current');
        }
      }
    });
  });
}

function init() {
  if (document.querySelector('[data-controller*="ac-data-table"]')) {
    drawDataTable();
  }
}

export default init;
